import { getCache } from "../../util/Cache";

export const fetchGetLPPAll = async () => {
    let key = process.env.REACT_APP_API_KEY || '';
    var myHeaders = new Headers();
    myHeaders.append("Authorization", key); 
    const url = process.env.REACT_APP_API_URL + "/hublang/lpp";    
    try {
        const response = await fetch(url,{
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        })

        const result = await response.json();
        return { status: result.status, data: result.data.data };

    } catch (error) {
        console.error('Error:', error);
        return { status: 500, message: "Terjadi kesalahan pada server", data: [] };
    }
};

export const fetchPetugasAvailable = async () => {
    let key = process.env.REACT_APP_API_KEY || '';
    var myHeaders = new Headers();
    myHeaders.append("Authorization", key); 
    const url = process.env.REACT_APP_API_URL + "/hublang/lpp/petugas";    
    try {
        const response = await fetch(url,{
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        })

        const result = await response.json();
        return { status: result.status, data: result.data };

    } catch (error) {
        console.error('Error:', error);
        return { status: 500, message: "Terjadi kesalahan pada server", data: [] };
    }
}

export const fetchPrintLpp = async (body : any, petugas : string) => {
  let key = process.env.REACT_APP_API_KEY || '';
  const url = process.env.REACT_APP_API_URL;
  const myHeaders = new Headers();
  myHeaders.append("Authorization", key);
  myHeaders.append("Content-Type", "application/json");
  const dataSend = { body : body , petugas_loket : petugas }

  return await fetch(url + "/hublang/lpp/print", {
    method: "POST",
    headers: myHeaders,
    redirect: "follow",
    body: JSON.stringify(dataSend)
  })
    .then((response) => response.json())
    .then((result) => { console.log(result); return result; })
    .catch((error) => console.error(error));
}

export const fetchGetTagihanLoket = async (linkto : string = "") => {
    let key = process.env.REACT_APP_API_KEY || '';
    var myHeaders = new Headers();
    myHeaders.append("Authorization", key); 
    const url = `${linkto === 'sapto' ? process.env.REACT_APP_API_URL_V2 : process.env.REACT_APP_API_URL}/hublang/tunggakan`;    
    try {
        const response = await fetch(url,{
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        })
  
        const result = await response.json();
        return { status: result.status, data: result.data };
  
    } catch (error) {
        console.error('Error:', error);
        return { status: 500, message: "Terjadi kesalahan pada server", data: [] };
    }
};

export const fetchGetPiutangStatus = async (bulan: string, tahun: string, kecamatan: string, statusPiutang: string) => {
    let key = process.env.REACT_APP_API_KEY || '';
    var myHeaders = new Headers(); 
    myHeaders.append("Authorization", key);
    const url = `${process.env.REACT_APP_API_URL}/hublang/tunggakan/status-date?bulan=${bulan}&tahun=${tahun}&kecamatan=${kecamatan}&status=${statusPiutang}`;
    try {
        const response = await fetch(url,{
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        })
  
        const result = await response.json();
        return { status: result.status, data: result.data };
    } catch (error) {
        console.error('Error:', error);
        return { status: 500, message: "Terjadi kesalahan pada server", data: [] };
    }
};

export const fetchGetTagihanLoketTransfer = async (date : string) => {
    let key = process.env.REACT_APP_API_KEY || '';
    var myHeaders = new Headers();
    myHeaders.append("Authorization", key); 
    const url = process.env.REACT_APP_API_URL + "/hublang/tunggakan/transfer-list";    
    
    const formdata = new FormData();
    formdata.append("date", date);
    
    try {
        
        const response = await fetch(url,{
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: formdata
        })
  
        const result = await response.json();
        return { status: result.status, data: result.data };
  
    } catch (error) {
        console.error('Error:', error);
        return { status: 500, message: "Terjadi kesalahan pada server", data: [] };
    }
}

export const fetchGetTagihanLoketNsb = async (nsb : string, linkto : string = "") => {
    let key = process.env.REACT_APP_API_KEY || '';
    var myHeaders = new Headers();
    myHeaders.append("Authorization", key); 
    const url = `${linkto === 'sapto' ? process.env.REACT_APP_API_URL_V2 : process.env.REACT_APP_API_URL}/hublang/tunggakan/${nsb}`;    
    try {
        const response = await fetch(url,{
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        })
  
        const result = await response.json();
        return { status: result.status, data: result.data };
  
    } catch (error) {
        console.error('Error:', error);
        return { status: 500, message: "Terjadi kesalahan pada server", data: [] };
    }
}

export const fetchPutTagihanLoket = async (body : any) => {
    const [tahun, bulan, hari] = body.tanggal_bayar.split("/");
    const tanggalbyr = hari ?? String(new Date().getDate()).padStart(2, '0');
    const bulanbyr = bulan ?? String(new Date().getMonth() + 1).padStart(2, '0');
    const tahunbyr = tahun ?? new Date().getFullYear();

    const tanggalhariini = body.tanggal_bayar ?? `${tahunbyr}/${bulanbyr}/${tanggalbyr}`;

    const bersihkanDataTagihan = async (data : any) => {
        return {
            PMETER          : '', 
            NAMA            : body.nama,
            NSB             : body.nsb,
            ALAMAT          : '',
            KECAMATAN       : body.kecamatan,
            DESA            : body.desa,
            KLAS            : body.klasf,
            STATUS          : body.status,
            KETERANGAN      : 'Lunas',
            PELANGGAN       : body.pelanggan,
            BULAN           : body.BULAN,
            TAHUN           : body.TAHUN,
            MLALU           : body.MLALU,
            MKINI           : body.MKINI,
            PAKAI           : body.PAKAI,
            VOLUME          : body.VOLUME,
            HAIR            : body.HAIR,
            ADM             : body.ADM,
            TOTAL           : body.TOTAL,
            SUBSIDI         : body.SUBSIDI,
            DENDA           : body.DENDA,
            ID_LOKET        : '',
            P_LOKET         : '',
            TOTAL_BYR       : body.TOTAL_BYR,
            LOKET           : '1',
            BULANBYR        : bulanbyr,
            TAHUNBYR        : tahunbyr,
            TGLBM           : '',
            TGLBYRTGL       : tanggalhariini,
            row             : '1',
            photo           : '',
            TGL             : tanggalbyr,
            time            : '',
            TGLTIME         : tanggalhariini,
            TGLBTL          : '',
            userid          : '',
            mode_print      : body.mode_print,
            bukti_transfer  : body.bukti_transfer || '',
        }
    }

    body = await bersihkanDataTagihan(body)
    
    let key = process.env.REACT_APP_API_KEY || '';
    var myHeaders = new Headers();
    myHeaders.append("Authorization", key); 

    const formData = new FormData();
    Object.entries(body).forEach(([key, value]) => {
        formData.append(key, value as any);
    });
    const url = process.env.REACT_APP_API_URL + "/hublang/tunggakan";    
    try {
        const response = await fetch(url,{
            method: 'PUT',
            body: formData,
            headers: myHeaders,
            redirect: 'follow'
        })
  
        const result = await response.json();
        return { status: result.status, data: result.data };
  
    } catch (error) {
        console.error('Error:', error);
        return { status: 500, message: "Terjadi kesalahan pada server", data: [] };
    }
}


export const fetchPatchVerif = async (id : string, verif : string) => {
    const today = new Date();

    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); 
    const day = String(today.getDate()).padStart(2, "0");

    const formatted = `${year}-${month}-${day}`;

    const petugas_cache = await getCache("current_user");

    // const myHeaders = new Headers();
    // myHeaders.append("Authorization", "Bearer| 77d91eb643e7c9606940");

    // const formdata = new FormData();
    // formdata.append("id", "7");
    // formdata.append("verif", "penagihan");
    // formdata.append("person", "Alan Zulfikar");
    // formdata.append("history_date", "2025-11-19");

    // const requestOptions = {
    // method: "PATCH",
    // headers: myHeaders,
    // body: formdata,
    // redirect: "follow"
    // };

    // fetch("http://localhost:4474/gt/v1/hublang/lpp/terbentuk/verif", requestOptions)
    // .then((response) => response.text())
    // .then((result) => console.log(result))
    // .catch((error) => console.error(error));

    let key = process.env.REACT_APP_API_KEY || '';
    var myHeaders = new Headers();
    myHeaders.append("Authorization", key);
    
    const formdata = new FormData();
    formdata.append("id", id);
    formdata.append("verif", verif);
    formdata.append("person", petugas_cache.username);
    formdata.append("history_date", formatted);

    // console.log(id, verif, petugas_cache.username, formatted);

    const url = process.env.REACT_APP_API_URL + "/hublang/lpp/terbentuk/verif";    
    try {
        const response = await fetch(url,{
            method: "PATCH",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        })
  
        return { status: response.status, message : response.statusText };
  
    } catch (error) {
        console.error('Error:', error);
        return { status: 500, message: "Terjadi kesalahan pada server", data: [] };
    }

    // const [year, month, day] = tanggal_lpp.split("-");

    // const formattedTgl = `${day}-${month}-${year}`;
    
}
